import React, { FC, useCallback, useMemo, ChangeEvent, useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

import {
  EditorState,
  RichUtils,
  ContentBlock,
} from 'draft-js'

import {
  getSelectedBlocksList,
} from 'draftjs-utils'

import EditorContext from './EditorContext'

import {
  ITextEditor_EditorUpdate,
  ITextEditor_BlockType,
} from '@kaidam/fc-shared/src/types/texteditor'

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: '0.8em',
    color: theme.palette.grey[800],
  },
}))

interface ToolbarSelectBlockProps {
  types: ITextEditor_BlockType[],
  defaultValue: string,
  editorState: EditorState,
  setEditorState: ITextEditor_EditorUpdate,
}

const ToolbarSelectBlock: FC<React.PropsWithChildren<ToolbarSelectBlockProps>> = ({
  types,
  defaultValue,
  editorState,
  setEditorState,
}) => {

  const editorContext = useContext(EditorContext)

  const classes = useStyles()
  const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setEditorState(
      RichUtils.toggleBlockType(editorState, event.target.value as string)
    )
    setTimeout(() => {
      editorContext.focus()
    }, 0)
  }, [
    editorState,
  ])

  const currentType = useMemo<string>(() => {
    if(!editorState) return ''
    const blocks = getSelectedBlocksList(editorState) as ContentBlock[]
    const allTypes = blocks.reduce<Record<string, boolean>>((all, block) => {
      all[block.getType()] = true
      return all
    }, {})
    if(Object.keys(allTypes).length != 1) return ''
    return Object.keys(allTypes)[0]
  }, [
    editorState,
  ])

  const disabled = !currentType || !types.find(t => t.type == currentType)
  const useValue = disabled ? defaultValue : currentType

  return (
    <FormControl>
      <Select
        className={ classes.select }
        value={ useValue }
        disabled={ disabled }
        onChange={ onChange }
        onMouseDown={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        {
          types.map(type => (
            <MenuItem key={ type.type } value={ type.type }>{ type.title }</MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )
}

export default ToolbarSelectBlock